if (!customElements.get('td-sign-up-modal')) {
  class TdSignUpModal extends HTMLElement {
  
    constructor() {
      super();
      this.FORM = this.querySelector('[data-sign-up-form]');
      this.SUBSCRIBE_LIST_ID = 'TQsZvQ'; 
      this.CAD_FILE_LIST_ID = 'Yh366T';
      this.API_KEY = 'SaFMEC'; // Klaviyo public API key

      this.MODAL_TRIGGERS = document.querySelectorAll('[data-sign-up-trigger]');
      this.MODAL_CLOSE_ELMS = this.querySelectorAll('[data-sign-up-close]');
      this.ACTIVE_CLASS = 'td-active';

      this.DOWNLOAD_LINK_ELM = this.querySelector('[data-download-link]');

      this.downloadLink = null;
    }
  
    connectedCallback() {
      if (!this.FORM || !this.DOWNLOAD_LINK_ELM) {
        return;
      }
      this.attachListeners();
    }
  
    attachListeners() {
      this.FORM.addEventListener('submit', this.handleSubmit.bind(this));
      this.MODAL_TRIGGERS.forEach((trigger) => {
        trigger.addEventListener('click', this.openModal.bind(this));
      });
      this.MODAL_CLOSE_ELMS.forEach((close) => {
        close.addEventListener('click', this.closeModal.bind(this));
      });
    }

    openModal(e) {
      e.preventDefault();
      //set download link for post form submit
      this.downloadLink = e.target.href;

      this.classList.add(this.ACTIVE_CLASS);
    }

    closeModal(e) {
      e.preventDefault();
      //reset download link
      this.downloadLink = null;

      this.classList.remove(this.ACTIVE_CLASS);
    }

    async handleSubmit(event) {
      event.preventDefault();
      const email = this.querySelector('[data-email]')?.value;
      const subscribe = this.querySelector('[data-subscribe]')?.checked;
      if (!email) {
        console.error('Email field is required.');
        return;
      }
      let body = {
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  subscriptions: {
                    email: { marketing: { consent: "SUBSCRIBED" } },
                  },
                  email: email,
                },
              },
            },
          },
          relationships: {
            list: { data: { type: "list", id: this.SUBSCRIBE_LIST_ID } },
          },
        },
      };
      if (!subscribe) {
        body = {
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              list: { data: { type: "list", id: this.CAD_FILE_LIST_ID } },
            },
          },
        };
      }

      const options = {
        method: 'POST',
        headers: {revision: '2025-01-15', 'content-type': 'application/vnd.api+json'},
        body: JSON.stringify(body)
      };
      
      fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${this.API_KEY }`, options)
        .then(res => {
          if (res.ok) {
            this.exposeDownloadLink();
          } else {
            console.error('Failed to subscribe:', res.statusText);
          }
        })
        .catch(err => console.error(err));
    }

    exposeDownloadLink() {
      if (this.downloadLink) {
        this.FORM.reset();
        this.FORM.classList.remove(this.ACTIVE_CLASS);
        this.DOWNLOAD_LINK_ELM.href = this.downloadLink;
        this.DOWNLOAD_LINK_ELM.classList.add(this.ACTIVE_CLASS);
      }
    }
    
  }
  customElements.define('td-sign-up-modal', TdSignUpModal);
}